import React from 'react';
import cx from 'classnames';
import { IconText } from '../../IconText';
import { VisuallyHidden } from '../VisuallyHidden';
import { resolveValidationIcon, resolveValidationSize } from './InputWrapper.helpers';
import styles from './InputWrapper.module.scss';
export const InputWrapper = (props) => {
    const { __internal, append, children, className = '', fullWidth, intent, label, labelProps, prepend, rootProps, showLabel, size = 'medium', validationMessage, wrapperProps, } = props;
    const validationProps = {
        icon: resolveValidationIcon(intent),
        variant: resolveValidationSize(size),
    };
    const hasGap = showLabel || validationMessage;
    return (<>
			<div {...rootProps} className={cx(styles.component, styles[size], __internal?.rootClassName, {
            [styles.fullWidth]: fullWidth,
            [styles.hasGap]: hasGap,
            [styles.hasAppend]: !!append,
            [styles.hasPrepend]: !!prepend,
            [styles[intent]]: intent,
        }, className)}>
				
				{label ? (<label {...labelProps}>
						{showLabel ? <span className={styles.label}>{label}</span> : <VisuallyHidden>{label}</VisuallyHidden>}
					</label>) : null}
				{validationMessage && <IconText data-thc-input-validation {...validationProps} text={validationMessage}/>}
				<div {...wrapperProps} data-thc-input-wrapper className={cx(styles.wrapper)}>
					{prepend}
					<div className={styles.box}>
						{children}
						{(append || prepend) && (<>
								
								<label {...labelProps} aria-hidden className={styles.focusButton} tabIndex={-1}/>
							</>)}
						<span className={styles.focusRing}/>
					</div>
					{append}
				</div>
			</div>
		</>);
};
